import { render, staticRenderFns } from "./library-role-editor.vue?vue&type=template&id=3847a78f&scoped=true&"
import script from "./library-role-editor.vue?vue&type=script&lang=js&"
export * from "./library-role-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3847a78f",
  null
  
)

export default component.exports